/**
 * Aplatit une réponse auth backend (enveloppe `{ success, data }` ou payload plat legacy).
 * Aligné sur le contrat web (`unwrapApiData`) : `success: false` / `data` null → erreur claire.
 */
export function unwrapAuthPayload<T>(
  body: unknown,
  fallbackMessage = "Réponse auth invalide",
): T {
  if (body == null || typeof body !== "object") {
    throw new Error(fallbackMessage);
  }

  const record = body as Record<string, unknown>;
  const isEnvelope = typeof record.success === "boolean";

  if (isEnvelope) {
    if (record.success === false) {
      const message =
        typeof record.message === "string" && record.message.trim()
          ? record.message.trim()
          : typeof record.error === "string" && record.error.trim()
            ? record.error.trim()
            : fallbackMessage;
      throw new Error(message);
    }

    if ("data" in record) {
      if (record.data == null) {
        const message =
          typeof record.message === "string" && record.message.trim()
            ? record.message.trim()
            : fallbackMessage;
        throw new Error(message);
      }
      if (typeof record.data !== "object" || Array.isArray(record.data)) {
        throw new Error(fallbackMessage);
      }
      return record.data as T;
    }
  }

  if (
    "data" in record &&
    record.data != null &&
    typeof record.data === "object" &&
    !Array.isArray(record.data) &&
    ("accessToken" in (record.data as object) ||
      "user" in (record.data as object) ||
      "refreshToken" in (record.data as object))
  ) {
    return record.data as T;
  }

  return record as T;
}
